import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import AccountsHierarchy from './AccountsHierarchy';
import { intlShape } from '../../../components/prop-types';


const messages = defineMessages({
  familyAccountsHierarchyHeader: {
    id: 'menu.accounts.familyAccountsHierarchy',
    defaultMessage: 'Family Accounts hierarchy',
  },
});

const FamilyAccountsHierarchy = ({ intl: { formatMessage } }) => (
  <AccountsHierarchy
    header={formatMessage(messages.familyAccountsHierarchyHeader)}
    onlyFamilyAccounts
  />
);

FamilyAccountsHierarchy.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(FamilyAccountsHierarchy);
